import Swiper from 'swiper';
// core version + navigation, pagination modules:
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper/core';

export default function backgroundSlider() {
  const selector = '.c-background-slider';
  if ($(selector).length > 0) {
    // configure Swiper to use modules
    SwiperCore.use([Navigation, Pagination, Autoplay]);

    const swiperConfig = {
      speed: 1000,
      loop: true,
      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        clickable: true,
        el: '.swiper-pagination',
        type: 'bullets',
      },
      on: {
        init: function () {
          // A hack to ensure that part of the next slide doesn't show
          setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
          }, 100);
        },
      },
    };

    if ($(selector).data('autoplay')) {
      swiperConfig.autoplay = {
        delay: 5000,
        disableOnInteraction: false,
      };
    }

    // init Swiper:
    new Swiper(selector, swiperConfig);

    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 500);
  }
}



// WEBPACK FOOTER //
// ./scripts/components/backgroundSlider.js